import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./css/HeatmapPage.css";

interface HeatmapMonthlyProps {
    year: number;
    registros: { fecha: string }[];
    periodDates: Set<string>;
    activeDate: Date | null;
    dayLogs: any[];
    favoriteMode: boolean;
    favoriteDates: Set<string>;
    onDayClick: (date: Date) => void;
}

const HeatmapMonthly: React.FC<HeatmapMonthlyProps> = ({ year, registros, activeDate, dayLogs, periodDates, favoriteMode, favoriteDates, onDayClick }) => {

    const conteo: Record<string, number> = {};
    registros.forEach(r => {
        conteo[r.fecha] = (conteo[r.fecha] || 0) + 1;
    });

    const obtenerNivel = (date: Date) => {
        const key = date.toLocaleDateString("sv-SE");
        const valor = conteo[key] || 0;

        if (valor === 0) return "lvl-0";
        if (valor === 1) return "lvl-1";
        if (valor === 2) return "lvl-2";
        if (valor === 3) return "lvl-3";
        if (valor >= 4) return "lvl-4";
        return "lvl-5";
    };

    const getPopoverPosition = (date: Date) => {
        const day = date.getDay(); // 0 = domingo, 6 = sábado

        // Columna derecha → anclar a la derecha
        if (day === 0) return "left";   // domingo

        // Columna izquierda → anclar a la izquierda
        if (day === 1) return "right";  // sábado

        return "center";
    };

    return (
        <div className="heatmap-months">
            {Array.from({ length: 12 }).map((_, mes) => (
                <div key={mes} className="calendar-wrapper">
                    <h4>
                        {new Date(year, mes).toLocaleString("es", { month: "long" }).toUpperCase()}
                    </h4>

                    <Calendar
                        activeStartDate={new Date(year, mes, 1)}
                        view="month"
                        showNavigation={false}
                        showNeighboringMonth={false}
                        value={null}
                        onClickDay={(date, event) => {
                            event.stopPropagation();
                            onDayClick(date);
                        }}
                        tileClassName={({ date, view }) =>{
                            if (view !== "month") return null;

                            const key = date.toLocaleDateString("sv-SE");
                            const nivel = obtenerNivel(date);
                            const isPeriod = periodDates.has(key);

                            const today = new Date();
                            const isToday =
                                date.getFullYear() === today.getFullYear() &&
                                date.getMonth() === today.getMonth() &&
                                date.getDate() === today.getDate();

                            return [
                                nivel,
                                isPeriod ? "period-day" : null,
                                isToday ? "today-day" : null
                            ].filter(Boolean).join(" ");
                        }}
                        tileContent={({ date, view }) => {
                            if (view !== "month") return null;

                            const key = date.toLocaleDateString("sv-SE");
                            const isFavoriteDay = favoriteDates.has(key);

                            return (
                                <>
                                    <div className="day-inner" />

                                    {/* ⭐ ESTRELLA */}
                                    {isFavoriteDay && favoriteMode && (
                                        <div className="day-star">★</div>
                                    )}

                                    {activeDate?.toDateString() === date.toDateString() &&
                                        dayLogs.length > 0 && (
                                            <div
                                                className={`day-popover popover-${getPopoverPosition(date)}`}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="day-popover-content">
                                                    {dayLogs.map(log => {
                                                        const date = log.createdAt.toDate();

                                                        const hora = date.toLocaleTimeString("es-ES", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit"
                                                        });

                                                        return (
                                                            <div key={log.id} className="log-row">
                                                                <span className="log-time">{hora}</span>
                                                                {favoriteMode && log.favorite && (
                                                                    <span className="log-star">★</span>
                                                                )}
                                                                <span className="log-total">
                                                                    Total: {log.totalAfter}
                                                                </span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <div className="day-popover-arrow" />
                                            </div>
                                        )}
                                </>
                            );
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default HeatmapMonthly;
